export const DEFAULT_SEARCH_RESULT_IMAGE_URL =
  'https://eu-images.contentstack.com/v3/assets/blt6bc5d603a5c04354/blt7df510b7e7e9bc32/6899c9fdf918fc7640944d2b/gradient-medium.png';
